<div class="min-h-screen flex flex-col relative">
  <div
    class="absolute inset-0 bg-[url('assets/patrones/fondo_patron_subito.webp')] bg-repeat opacity-30 backdrop-blur-sm"
  ></div>
  <div class="relative z-10 flex flex-col min-h-screen">
    <shared-header></shared-header>
    <main class="flex-grow">
      <router-outlet></router-outlet>
      @if(authenticate){
      <shared-chat-call-center></shared-chat-call-center>
      }
    </main>
    <shared-footer></shared-footer>
      @if(authenticate){
    <shared-push-notification></shared-push-notification>
      }
  </div>
</div>
